import { Injectable } from '@angular/core';
import { BehaviorSubject, interval, Subscription, switchMap, takeWhile, Subject, filter } from 'rxjs';
// import { ReportsService } from '../../reports/reports.service';
import { ToastrService } from 'ngx-toastr';
import { ReportsService } from '../../reports-new/reports.service';

@Injectable({
  providedIn: 'root' // so it’s singleton across app
})
export class CommonService {
  private reportPollingSub?: Subscription;
  // notify components when completed
  private reportCompletedSource = new BehaviorSubject<boolean>(false);
  reportCompleted$ = this.reportCompletedSource.asObservable();

  constructor(private reportsService: ReportsService,
    private toastr: ToastrService
  ) { }

  startReportPolling() {

    if (this.reportPollingSub) return;

    this.reportPollingSub = interval(15000)
      .pipe(
        switchMap(() => this.reportsService.generateReport()),
        takeWhile(
          (res: any) => res?.body?.data?.is_generating === true,
          true // emit last value when false
        )
      )
      .subscribe({
        next: (res: any) => {
          const isGenerating = res?.body?.data?.is_generating
          const status = res?.body?.responseCode;

          if (status !== 200) {
            this.toastr.error(res?.data?.responseMessage || 'Report failed');
            this.stopReportPolling();
            return;
          }
          // ✅ COMPLETED
          if (isGenerating === false) {
            this.toastr.success(
              'Report generated successfully!',
              'Completed'
            );
            this.reportCompletedSource.next(true);
            this.stopReportPolling();
          }
        },
        error: err => {
          console.error('Polling error', err);
          this.toastr.error(
            'Error while checking report status',
            'Error'
          );
          this.stopReportPolling();
        }
      });
  }

  stopReportPolling() {
    this.reportPollingSub?.unsubscribe();
    this.reportPollingSub = undefined;
  }

  private dataSource = new Subject<any>();
  data$ = this.dataSource.asObservable();
  sendData(data: any) {
    this.dataSource.next(data);
  }

  private triggerAdvancedFilterSource = new Subject<any>();
  triggerAdvancedFilter$ = this.triggerAdvancedFilterSource.asObservable();
  callAdvancedFilter(data: any) {
    this.triggerAdvancedFilterSource.next(data);
  }

  private selectedZonesSource = new Subject<any>();
  selectedZones$ = this.selectedZonesSource.asObservable();
  updateSelectedZones(zones: any) {
    this.selectedZonesSource.next(zones);
  }

  private selectedRegionSource = new Subject<any>();
  selectedRegions$ = this.selectedRegionSource.asObservable();
  updateSelectedRegions(regions: any) {
    this.selectedRegionSource.next(regions);
  }

  private selectedAreaSource = new Subject<any>();
  selectedAreas$ = this.selectedAreaSource.asObservable();
  updateSelectedAreas(areas: any) {
    this.selectedAreaSource.next(areas);
  }


  clearAllSelections() {
    this.selectedZonesSource.next(null);
    this.selectedRegionSource.next(null);
    this.selectedAreaSource.next(null);
  }


  getDateRangeToggleData() {
    const storedData = sessionStorage.getItem("dateRangeToggle");

    if (storedData) {
      try {
        const parsed = JSON.parse(storedData);
        return parsed;

      } catch (err) {
        console.error("Invalid session data:", err);
      }
    }
  }

  getAdvanceFilterData() {
    const storedData = sessionStorage.getItem("advanceFilterObj");

    if (storedData) {
      try {
        const parsed = JSON.parse(storedData);
        return parsed;

      } catch (err) {
        console.error("Invalid session data:", err);
      }
    }
  }

  getCardFilterData() {
    const storedData = sessionStorage.getItem("filterObj");

    if (storedData) {
      try {
        const parsed = JSON.parse(storedData);
        return parsed;

      } catch (err) {
        console.error("Invalid session data:", err);
      }
    }
  }

  filterAllowedKeys(data: any, allowedKeys: string[]) {
    if (!data) return {};
    return Object.fromEntries(
      Object.entries(data || {}).filter(([key]) =>
        allowedKeys.includes(key)
      )
    );
  }

}
